import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconChevronRightLarge = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M8.672 4.477a.73.73 0 0 0-.211.539c0 .203.07.375.21.515L15.142 12l-6.47 6.469a.73.73 0 0 0-.21.539c0 .203.07.375.21.515a.74.74 0 0 0 .54.235.667.667 0 0 0 .516-.235l6.656-6.632c.25-.25.375-.547.375-.891s-.125-.64-.375-.89L9.727 4.476a.668.668 0 0 0-.516-.235.741.741 0 0 0-.54.235z" }),
});

export { IconChevronRightLarge };
